import axios from 'axios';

const PATH = `${process.env.VUE_APP_POST_API}${process.env.VUE_APP_API_ORDER_PROCESS}`;

/** 訂單成立 */
export default (args) => {
  // 是否顯示遮罩
  args.isShowLoading = false;

  function stringifyData(obj) {
    return Object.entries(obj || {})
      .filter(([, v]) => v !== null && v !== undefined)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
  }

  // config
  const config = {
    method: 'POST',
    timeout: 5 * 60 * 1000, // (timeout 等待 5 分鐘)
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: stringifyData(args),
    url: PATH,
  };

  /** Lab，目前暫時使用假 API，所以需要 false */
  return axios(config);
};
